import { COLORS } from '@btime/constants'
import React from 'react'

import { PermissionChecker } from '../../session'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import Container from '../../../components/structure/Container'
import FilterWrapper from './filters/FilterWrapper'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import Separator from '../../../components/helpers/Separator'

const LogsListPage = () => {
  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor={COLORS.white}>
      <PermissionChecker ownerOnly>
        <Container>
          <FilterWrapper>
            <PageHeader />
            <PageContent />
          </FilterWrapper>

          <Separator weight={32} />
        </Container>
      </PermissionChecker>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default LogsListPage
